import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/Layout';
import HeroSection from '../components/shared/HeroSection';
import SectionTitle from '../components/shared/SectionTitle';
import CTASection from '../components/shared/CTASection';
import PaymentOptions from '../components/shared/PaymentOptions';
import { FadeInOnScroll } from '../components/shared/Parallax';
import { companyInfo } from '../data/mock';
import { Truck, Clock, Store, Phone, CheckCircle, Package, Scissors, MapPin, QrCode, Video, Wrench, Mail, MessageCircle, Palette, Award, AlertTriangle, ArrowRight, Calendar, CreditCard, CheckSquare, Send, Loader2, User, Home, Ruler, ShoppingCart, FileText, Settings, Layers } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';

const ShopPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [termsAccepted, setTermsAccepted] = useState(false);
  
  // Form state per Ordina Online
  const [ordinaForm, setOrdinaForm] = useState({
    nome: '',
    indirizzo: '',
    email: '',
    telefono: '',
    prodotto: '',
    larghezza: '',
    altezzaSporgenza: '',
    coloreStruttura: '',
    piano: '',
    manovra: '',
    attacco: '',
    codiceTessuto: '',
    cucitoSaldato: '',
    bordatura: '',
    formaMantovana: '',
    motore: '',
    consegna: '',
    note: ''
  });
  const [isSubmittingOrdina, setIsSubmittingOrdina] = useState(false);
  const [ordinaSubmitted, setOrdinaSubmitted] = useState(false);

  const handleOrdinaChange = (e) => {
    const { name, value } = e.target;
    setOrdinaForm(prev => ({ ...prev, [name]: value }));
  };

  const handleOrdinaSelectChange = (name, value) => {
    setOrdinaForm(prev => ({ ...prev, [name]: value }));
  };

  const handleOrdinaSubmit = async (e) => {
    e.preventDefault();
    
    // Validazione campi obbligatori
    if (!ordinaForm.nome || !ordinaForm.indirizzo || !ordinaForm.telefono || 
        !ordinaForm.prodotto || !ordinaForm.larghezza || !ordinaForm.altezzaSporgenza ||
        !ordinaForm.coloreStruttura || !ordinaForm.codiceTessuto || !ordinaForm.motore || !ordinaForm.consegna) {
      toast.error('Compila tutti i campi obbligatori');
      return;
    }

    if (!termsAccepted) {
      toast.error('Devi accettare i termini e condizioni');
      return;
    }

    setIsSubmittingOrdina(true);

    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${API_URL}/api/ordina-online`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nome: ordinaForm.nome,
          indirizzo: ordinaForm.indirizzo,
          email: ordinaForm.email,
          telefono: ordinaForm.telefono,
          prodotto: ordinaForm.prodotto,
          larghezza: ordinaForm.larghezza,
          altezza_sporgenza: ordinaForm.altezzaSporgenza,
          colore_struttura: ordinaForm.coloreStruttura,
          piano: ordinaForm.piano,
          manovra: ordinaForm.manovra,
          attacco: ordinaForm.attacco,
          codice_tessuto: ordinaForm.codiceTessuto,
          cucito_saldato: ordinaForm.cucitoSaldato,
          bordatura: ordinaForm.bordatura,
          forma_mantovana: ordinaForm.formaMantovana,
          motore: ordinaForm.motore,
          consegna: ordinaForm.consegna,
          note: ordinaForm.note
        }),
      });

      if (response.ok) {
        setOrdinaSubmitted(true);
        toast.success('Richiesta inviata con successo! Riceverai il preventivo via email.');
        setOrdinaForm({
          nome: '', indirizzo: '', email: '', telefono: '', prodotto: '',
          larghezza: '', altezzaSporgenza: '', coloreStruttura: '', piano: '',
          manovra: '', attacco: '', codiceTessuto: '', cucitoSaldato: '',
          bordatura: '', formaMantovana: '', motore: '', consegna: '', note: ''
        });
      } else {
        const errorData = await response.json();
        toast.error(errorData.detail || 'Errore nell\'invio della richiesta');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Errore di connessione. Riprova più tardi.');
    } finally {
      setIsSubmittingOrdina(false);
    }
  };
  
  // Form state per Cappottine 24h
  const [cappottinaForm, setCappottinaForm] = useState({
    nome: '',
    indirizzo: '',
    email: '',
    telefono: '',
    larghezza: '',
    sporgenza: '',
    codiceTessuto: '',
    note: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleCappottinaChange = (e) => {
    const { name, value } = e.target;
    setCappottinaForm(prev => ({ ...prev, [name]: value }));
  };

  const handleCappottinaSubmit = async (e) => {
    e.preventDefault();
    
    // Validazione campi obbligatori
    if (!cappottinaForm.indirizzo || !cappottinaForm.telefono) {
      toast.error('Compila tutti i campi obbligatori');
      return;
    }

    setIsSubmitting(true);

    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${API_URL}/api/cappottina-24h`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nome: cappottinaForm.nome,
          indirizzo: cappottinaForm.indirizzo,
          email: cappottinaForm.email,
          telefono: cappottinaForm.telefono,
          larghezza: cappottinaForm.larghezza,
          sporgenza: cappottinaForm.sporgenza,
          codice_tessuto: cappottinaForm.codiceTessuto,
          note: cappottinaForm.note,
          servizio: 'Cappottina 24h'
        }),
      });

      if (response.ok) {
        setFormSubmitted(true);
        toast.success('Richiesta inviata con successo! Ti contatteremo entro 24 ore.');
        setCappottinaForm({
          nome: '',
          indirizzo: '',
          email: '',
          telefono: '',
          larghezza: '',
          sporgenza: '',
          codiceTessuto: '',
          note: ''
        });
      } else {
        const errorData = await response.json();
        toast.error(errorData.detail || 'Errore nell\'invio della richiesta');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Errore di connessione. Riprova più tardi.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Layout>
      {/* Hero Section - SENZA tasto sfoglia prodotti */}
      <HeroSection
        title="Acquisti Online - Dal Produttore a Casa Tua"
        subtitle="Tende da sole nuove e cambi telo direttamente dalla nostra produzione. Spedizione in tutta Italia o ritiro in sede."
        ctaText="Scopri come funziona"
        ctaLink="#come-funziona"
        imageUrl="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1920&q=80"
        showScrollIndicator={true}
      />

      {/* USP Banner */}
      <section className="py-8 bg-sky-500 text-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-16 text-center">
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5" />
              <span className="font-medium">Produttori Diretti</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5" />
              <span className="font-medium">Qualità Superiore</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5" />
              <span className="font-medium">Spedizione Italia</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5" />
              <span className="font-medium">Ritiro in Sede</span>
            </div>
          </div>
        </div>
      </section>

      {/* Magazzino Tessuti Section */}
      <section className="py-16 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <FadeInOnScroll>
              <div>
                <span className="inline-block text-sm font-medium tracking-widest uppercase mb-4 text-amber-600">
                  Scegli il Tuo Tessuto
                </span>
                <h2 className="text-3xl md:text-4xl font-light text-gray-900 leading-tight mb-6">
                  Vieni a toccare con mano i tessuti Tempotest Parà
                </h2>
                <p className="text-lg text-gray-600 font-light leading-relaxed mb-6">
                  Anche se acquisti online, ti invitiamo a passare nel nostro <strong>showroom a Pisa</strong> per 
                  vedere e toccare con mano i tessuti del nostro <strong>ampio magazzino interno Tempotest Parà</strong>.
                </p>
                <p className="text-lg text-gray-600 font-light leading-relaxed mb-6">
                  Potrai sfogliare le centinaia di colori e fantasie disponibili, portare a casa 
                  campioni gratuiti e scegliere con calma il tessuto perfetto per la tua tenda.
                </p>
                <div className="bg-white p-6 rounded-lg border border-amber-200 mb-6">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-amber-500 flex items-center justify-center">
                      <MapPin className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">Tappezzeria Giovanni</p>
                      <p className="text-gray-600">{companyInfo.address.street}, {companyInfo.address.cap} {companyInfo.address.city} ({companyInfo.address.province})</p>
                      <p className="text-amber-600 font-medium">{companyInfo.phone}</p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeInOnScroll>
            <FadeInOnScroll delay={200}>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="text-3xl font-bold text-amber-500 mb-2">1000+</div>
                  <div className="text-sm text-gray-600">Colori disponibili</div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="text-3xl font-bold text-amber-500 mb-2">100%</div>
                  <div className="text-sm text-gray-600">Made in Italy</div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md col-span-2">
                  <div className="space-y-3">
                    <div className="flex items-center gap-3">
                      <CheckCircle className="w-5 h-5 text-green-500" />
                      <span className="text-gray-700">Campioni gratuiti da portare a casa</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <CheckCircle className="w-5 h-5 text-green-500" />
                      <span className="text-gray-700">Consulenza personalizzata inclusa</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <CheckCircle className="w-5 h-5 text-green-500" />
                      <span className="text-gray-700">Garanzia 5 anni Tempotest Parà</span>
                    </div>
                  </div>
                </div>
              </div>
            </FadeInOnScroll>
          </div>
        </div>
      </section>

      {/* COME FUNZIONA */}
      <section id="come-funziona" className="py-16 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <FadeInOnScroll>
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6">
                Due servizi, due esigenze diverse
              </h2>
              <p className="text-lg text-gray-600 mb-12">
                Offriamo due tipologie di servizio online. Scegli quello più adatto alle tue esigenze.
              </p>
              
              <div className="grid md:grid-cols-2 gap-8">
                {/* Servizio 1: Ordina Online */}
                <div className="p-8 bg-sky-50 border-2 border-sky-200 rounded-lg text-left">
                  <div className="w-14 h-14 rounded-full bg-sky-500 flex items-center justify-center mb-6">
                    <ShoppingCart className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-xl font-medium text-gray-900 mb-3">
                    Ordina Online
                  </h3>
                  <p className="text-gray-600 mb-4">
                    <strong>Tende da sole nuove, cappottine nuove, cambi telo.</strong> 
                    Strutture o teli completamente nuovi prodotti nel nostro laboratorio.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600 mb-6">
                    <li className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-sky-500" />
                      Spedizione in tutta Italia
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-sky-500" />
                      Oppure ritiro in sede a Pisa
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-sky-500" />
                      Montaggio fai da te (istruzioni incluse)
                    </li>
                  </ul>
                  <a href="#acquisto-online">
                    <Button className="w-full bg-sky-500 hover:bg-sky-600 text-white rounded-none">
                      Vai a Ordina Online
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </a>
                </div>

                {/* Servizio 2: Cappottine 24h */}
                <div className="p-8 bg-amber-50 border-2 border-amber-200 rounded-lg text-left">
                  <div className="w-14 h-14 rounded-full bg-amber-500 flex items-center justify-center mb-6">
                    <Clock className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-xl font-medium text-gray-900 mb-3">
                    Cappottine Pronte in 24h
                  </h3>
                  <p className="text-gray-600 mb-4">
                    <strong>Rifacimento telo cappottina esistente.</strong> 
                    Porti la tua cappottina in sede e la ritiri rinnovata dopo 24 ore.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600 mb-6">
                    <li className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-amber-500" />
                      Preventivo via email
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-amber-500" />
                      Consegna in sede a Pisa
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-amber-500" />
                      Ritiro dopo 24 ore
                    </li>
                  </ul>
                  <a href="#cappottine-24h">
                    <Button className="w-full bg-amber-500 hover:bg-amber-600 text-white rounded-none">
                      Vai al servizio 24h
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </FadeInOnScroll>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* SEZIONE 1: ORDINA ONLINE */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      
      <section id="acquisto-online" className="py-20 lg:py-28 bg-gray-50">
        <div className="container mx-auto px-6 lg:px-12">
          <FadeInOnScroll>
            <div className="text-center mb-16">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-sky-500 text-white rounded-full text-sm font-medium mb-4">
                <ShoppingCart className="w-4 h-4" />
                ORDINA ONLINE
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-gray-900 mb-4">
                Tende da Sole Nuove e Cambi Telo
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Acquista strutture completamente nuove o teli di ricambio. 
                Produzione nel nostro laboratorio, spedizione in tutta Italia o ritiro in sede.
              </p>
            </div>
          </FadeInOnScroll>

          {/* COME FUNZIONA - 5 STEP */}
          <FadeInOnScroll>
            <div className="max-w-5xl mx-auto mb-16">
              <div className="bg-white rounded-lg p-8 lg:p-12 shadow-lg border border-sky-100">
                <h3 className="text-2xl font-light text-gray-900 text-center mb-10">
                  Come funziona l'ordine online
                </h3>
                
                <div className="grid md:grid-cols-5 gap-4">
                  {/* Step 1 */}
                  <div className="text-center">
                    <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-sky-100 flex items-center justify-center relative">
                      <span className="text-xl font-bold text-sky-600">1</span>
                      <div className="hidden md:block absolute left-full top-1/2 w-full h-0.5 bg-sky-200 -translate-y-1/2"></div>
                    </div>
                    <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-sky-500/10 flex items-center justify-center">
                      <FileText className="w-5 h-5 text-sky-600" />
                    </div>
                    <h4 className="font-medium text-gray-900 mb-1 text-sm">Compila il Form</h4>
                    <p className="text-xs text-gray-500">
                      Inserisci tutti i dettagli della tua tenda
                    </p>
                  </div>

                  {/* Step 2 */}
                  <div className="text-center">
                    <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-sky-100 flex items-center justify-center relative">
                      <span className="text-xl font-bold text-sky-600">2</span>
                      <div className="hidden md:block absolute left-full top-1/2 w-full h-0.5 bg-sky-200 -translate-y-1/2"></div>
                    </div>
                    <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-sky-500/10 flex items-center justify-center">
                      <Mail className="w-5 h-5 text-sky-600" />
                    </div>
                    <h4 className="font-medium text-gray-900 mb-1 text-sm">Ricevi Preventivo</h4>
                    <p className="text-xs text-gray-500">
                      Ti inviamo il preventivo dettagliato via email
                    </p>
                  </div>

                  {/* Step 3 */}
                  <div className="text-center">
                    <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-sky-100 flex items-center justify-center relative">
                      <span className="text-xl font-bold text-sky-600">3</span>
                      <div className="hidden md:block absolute left-full top-1/2 w-full h-0.5 bg-sky-200 -translate-y-1/2"></div>
                    </div>
                    <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-sky-500/10 flex items-center justify-center">
                      <CreditCard className="w-5 h-5 text-sky-600" />
                    </div>
                    <h4 className="font-medium text-gray-900 mb-1 text-sm">Accetta e Paga</h4>
                    <p className="text-xs text-gray-500">
                      Conferma l'ordine e procedi al pagamento
                    </p>
                  </div>

                  {/* Step 4 */}
                  <div className="text-center">
                    <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-sky-100 flex items-center justify-center relative">
                      <span className="text-xl font-bold text-sky-600">4</span>
                      <div className="hidden md:block absolute left-full top-1/2 w-full h-0.5 bg-sky-200 -translate-y-1/2"></div>
                    </div>
                    <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-sky-500/10 flex items-center justify-center">
                      <Settings className="w-5 h-5 text-sky-600" />
                    </div>
                    <h4 className="font-medium text-gray-900 mb-1 text-sm">Produzione</h4>
                    <p className="text-xs text-gray-500">
                      Realizziamo la tua tenda nel nostro laboratorio
                    </p>
                  </div>

                  {/* Step 5 */}
                  <div className="text-center">
                    <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-sky-100 flex items-center justify-center">
                      <span className="text-xl font-bold text-sky-600">5</span>
                    </div>
                    <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-sky-500/10 flex items-center justify-center">
                      <Truck className="w-5 h-5 text-sky-600" />
                    </div>
                    <h4 className="font-medium text-gray-900 mb-1 text-sm">Consegna</h4>
                    <p className="text-xs text-gray-500">
                      Spedizione con tracking o ritiro in sede
                    </p>
                  </div>
                </div>

                {/* Info consegna */}
                <div className="mt-10 grid md:grid-cols-2 gap-4">
                  <div className="p-4 bg-sky-50 rounded-lg border border-sky-200">
                    <div className="flex items-center gap-3 mb-2">
                      <Truck className="w-5 h-5 text-sky-600" />
                      <span className="font-medium text-gray-900 text-sm">Se scegli la SPEDIZIONE</span>
                    </div>
                    <p className="text-xs text-gray-600">
                      Riceverai il <strong>codice tracking</strong> per seguire la consegna in tempo reale. 
                      Spedizione con corriere in tutta Italia.
                    </p>
                  </div>
                  <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                    <div className="flex items-center gap-3 mb-2">
                      <Store className="w-5 h-5 text-green-600" />
                      <span className="font-medium text-gray-900 text-sm">Se scegli il RITIRO IN SEDE</span>
                    </div>
                    <p className="text-xs text-gray-600">
                      Quando la tenda sarà pronta, riceverai una <strong>notifica via email o SMS</strong> 
                      per venirla a ritirare presso la nostra sede a Ghezzano (Pisa).
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </FadeInOnScroll>

          {/* ════════════════════════════════════════════════════════════════════ */}
          {/* FORM ORDINE NATIVO - SUBITO DOPO "COME FUNZIONA" */}
          {/* ════════════════════════════════════════════════════════════════════ */}
          
          <div className="max-w-3xl mx-auto mt-16">
            <FadeInOnScroll>
              <div className="text-center mb-8">
                <span className="inline-flex items-center gap-2 px-4 py-2 bg-sky-500 text-white rounded-full text-sm font-medium mb-4">
                  <FileText className="w-4 h-4" />
                  RICHIEDI PREVENTIVO
                </span>
                <h3 className="text-2xl font-light text-gray-900 mb-2">
                  Compila il form per ricevere il preventivo
                </h3>
                <p className="text-gray-600 text-sm">
                  Inserisci tutti i dettagli della tua tenda. Ti invieremo il preventivo via email.
                </p>
              </div>
            </FadeInOnScroll>

            {/* Tessuti Link - Prima del form */}
            <FadeInOnScroll delay={50}>
              <div className="text-center mb-8 p-6 bg-amber-50 rounded-lg border border-amber-200">
                <Palette className="w-10 h-10 text-amber-500 mx-auto mb-3" />
                <h4 className="text-lg font-medium text-gray-900 mb-2">
                  Prima di compilare: scegli il colore del tessuto
                </h4>
                <p className="text-gray-600 mb-4 text-sm">
                  Sfoglia le collezioni Tempotest Parà e segna il codice del colore che preferisci.
                </p>
                <Link to="/tessuti">
                  <Button variant="outline" className="border-amber-500 text-amber-600 hover:bg-amber-100 px-6 py-2 rounded-none">
                    <Palette className="w-4 h-4 mr-2" />
                    Sfoglia i Tessuti
                  </Button>
                </Link>
              </div>
            </FadeInOnScroll>

            {/* Termini e Condizioni */}
            <FadeInOnScroll delay={100}>
              <div className="bg-gray-800 text-white p-6 rounded-t-lg">
                <div className="flex items-start gap-4">
                  <AlertTriangle className="w-6 h-6 text-amber-400 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-medium text-amber-300 mb-2">Termini e Condizioni - Montaggio NON incluso</h4>
                    <p className="text-gray-300 text-sm mb-4">
                      Acquistando online, il montaggio è a carico del cliente. 
                      <strong className="text-white"> Giovanni Tende non si assume responsabilità per eventuali difetti o danni 
                      causati da un montaggio non corretto.</strong> Ti forniamo QR Code con istruzioni, video tutorial e assistenza telefonica.
                    </p>
                    <label className="flex items-center gap-3 cursor-pointer">
                      <input 
                        type="checkbox" 
                        checked={termsAccepted}
                        onChange={(e) => setTermsAccepted(e.target.checked)}
                        className="w-5 h-5 rounded border-amber-500 text-amber-500 focus:ring-amber-500"
                      />
                      <span className="text-amber-200 text-sm">
                        Ho letto e accetto. Sono consapevole che il montaggio è di mia responsabilità.
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </FadeInOnScroll>

            {/* Form Nativo */}
            <FadeInOnScroll delay={200}>
              <div className={`bg-white rounded-b-lg overflow-hidden shadow-xl transition-opacity duration-300 ${
                termsAccepted ? 'opacity-100' : 'opacity-40 pointer-events-none'
              }`}>
                {!termsAccepted && (
                  <div className="p-8 text-center">
                    <p className="text-gray-500">⬆️ Accetta i termini per visualizzare il form</p>
                  </div>
                )}
                {termsAccepted && !ordinaSubmitted && (
                  <form onSubmit={handleOrdinaSubmit} className="p-8 space-y-6">
                    {/* Nota campi obbligatori */}
                    <p className="text-sm text-gray-500 flex items-center gap-1">
                      <span className="text-red-500">*</span> Indica un campo obbligatorio
                    </p>

                    {/* DATI PERSONALI */}
                    <div className="border-b border-gray-200 pb-6">
                      <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
                        <User className="w-5 h-5 text-sky-500" />
                        Dati Personali
                      </h4>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label htmlFor="nome" className="text-gray-700 font-medium">
                            NOME E COGNOME <span className="text-red-500">*</span>
                          </Label>
                          <Input
                            id="nome"
                            name="nome"
                            type="text"
                            value={ordinaForm.nome}
                            onChange={handleOrdinaChange}
                            placeholder="La tua risposta"
                            required
                            className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="indirizzo" className="text-gray-700 font-medium">
                            INDIRIZZO <span className="text-red-500">*</span>
                          </Label>
                          <Input
                            id="indirizzo"
                            name="indirizzo"
                            type="text"
                            value={ordinaForm.indirizzo}
                            onChange={handleOrdinaChange}
                            placeholder="Via, numero, città, CAP"
                            required
                            className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="email" className="text-gray-700 font-medium">
                            EMAIL
                          </Label>
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            value={ordinaForm.email}
                            onChange={handleOrdinaChange}
                            placeholder="email@esempio.it"
                            className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="telefono" className="text-gray-700 font-medium">
                            NUMERO <span className="text-red-500">*</span>
                          </Label>
                          <Input
                            id="telefono"
                            name="telefono"
                            type="tel"
                            value={ordinaForm.telefono}
                            onChange={handleOrdinaChange}
                            placeholder="333 1234567"
                            required
                            className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12"
                          />
                        </div>
                      </div>
                    </div>

                    {/* DETTAGLI PRODOTTO */}
                    <div className="border-b border-gray-200 pb-6">
                      <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
                        <Package className="w-5 h-5 text-sky-500" />
                        Dettagli Prodotto
                      </h4>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label className="text-gray-700 font-medium">
                            PRODOTTO <span className="text-red-500">*</span>
                          </Label>
                          <Select onValueChange={(value) => handleOrdinaSelectChange('prodotto', value)} value={ordinaForm.prodotto}>
                            <SelectTrigger className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12">
                              <SelectValue placeholder="Seleziona prodotto" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="TENDA A BRACCIA">Tenda a Braccia</SelectItem>
                              <SelectItem value="TENDA ATTICO">Tenda Attico</SelectItem>
                              <SelectItem value="TENDA A CADUTA">Tenda a Caduta</SelectItem>
                              <SelectItem value="CAPPOTTINA">Cappottina</SelectItem>
                              <SelectItem value="CAMBIO TELO">Cambio Telo</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="space-y-2">
                          <Label className="text-gray-700 font-medium">
                            COLORE STRUTTURA <span className="text-red-500">*</span>
                          </Label>
                          <Select onValueChange={(value) => handleOrdinaSelectChange('coloreStruttura', value)} value={ordinaForm.coloreStruttura}>
                            <SelectTrigger className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12">
                              <SelectValue placeholder="Seleziona colore" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="BIANCO">Bianco</SelectItem>
                              <SelectItem value="ARGENTO">Argento</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="larghezza" className="text-gray-700 font-medium">
                            LARGHEZZA (cm) <span className="text-red-500">*</span>
                          </Label>
                          <Input
                            id="larghezza"
                            name="larghezza"
                            type="text"
                            value={ordinaForm.larghezza}
                            onChange={handleOrdinaChange}
                            placeholder="es. 300"
                            required
                            className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="altezzaSporgenza" className="text-gray-700 font-medium">
                            ALTEZZA / SPORGENZA (cm) <span className="text-red-500">*</span>
                          </Label>
                          <Input
                            id="altezzaSporgenza"
                            name="altezzaSporgenza"
                            type="text"
                            value={ordinaForm.altezzaSporgenza}
                            onChange={handleOrdinaChange}
                            placeholder="es. 200"
                            required
                            className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12"
                          />
                        </div>
                      </div>
                    </div>

                    {/* DETTAGLI INSTALLAZIONE */}
                    <div className="border-b border-gray-200 pb-6">
                      <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
                        <Wrench className="w-5 h-5 text-sky-500" />
                        Dettagli Installazione
                      </h4>
                      <div className="grid md:grid-cols-3 gap-4">
                        <div className="space-y-2">
                          <Label className="text-gray-700 font-medium">
                            A CHE PIANO DEVE ESSERE INSTALLATA?
                          </Label>
                          <Select onValueChange={(value) => handleOrdinaSelectChange('piano', value)} value={ordinaForm.piano}>
                            <SelectTrigger className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12">
                              <SelectValue placeholder="Seleziona piano" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="PIANO TERRA">Piano Terra</SelectItem>
                              <SelectItem value="PRIMO PIANO">Primo Piano</SelectItem>
                              <SelectItem value="SECONDO PIANO">Secondo Piano</SelectItem>
                              <SelectItem value="TERZO O PIU ALTO">Terzo o più alto</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="space-y-2">
                          <Label className="text-gray-700 font-medium">
                            MANOVRA
                          </Label>
                          <Select onValueChange={(value) => handleOrdinaSelectChange('manovra', value)} value={ordinaForm.manovra}>
                            <SelectTrigger className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12">
                              <SelectValue placeholder="Seleziona lato" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="DESTRA">Destra</SelectItem>
                              <SelectItem value="SINISTRA">Sinistra</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="space-y-2">
                          <Label className="text-gray-700 font-medium">
                            ATTACCO
                          </Label>
                          <Select onValueChange={(value) => handleOrdinaSelectChange('attacco', value)} value={ordinaForm.attacco}>
                            <SelectTrigger className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12">
                              <SelectValue placeholder="Seleziona attacco" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="SOFFITTO">Soffitto</SelectItem>
                              <SelectItem value="PARETE">Parete</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                      </div>
                    </div>

                    {/* TESSUTO E FINITURE */}
                    <div className="border-b border-gray-200 pb-6">
                      <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
                        <Palette className="w-5 h-5 text-sky-500" />
                        Tessuto e Finiture
                      </h4>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label htmlFor="codiceTessuto" className="text-gray-700 font-medium">
                            CODICE TESSUTO TEMPOTEST <span className="text-red-500">*</span>
                          </Label>
                          <Input
                            id="codiceTessuto"
                            name="codiceTessuto"
                            type="text"
                            value={ordinaForm.codiceTessuto}
                            onChange={handleOrdinaChange}
                            placeholder="es. 407/11"
                            required
                            className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12"
                          />
                          <p className="text-xs text-gray-500">
                            <Link to="/tessuti" className="text-sky-600 underline hover:text-sky-700">Sfoglia i tessuti</Link> per trovare il codice
                          </p>
                        </div>
                        <div className="space-y-2">
                          <Label className="text-gray-700 font-medium">
                            CUCITO O SALDATO
                          </Label>
                          <Select onValueChange={(value) => handleOrdinaSelectChange('cucitoSaldato', value)} value={ordinaForm.cucitoSaldato}>
                            <SelectTrigger className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12">
                              <SelectValue placeholder="Seleziona lavorazione" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="CUCITO">Cucito</SelectItem>
                              <SelectItem value="SALDATO">Saldato</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="bordatura" className="text-gray-700 font-medium">
                            BORDATURA
                          </Label>
                          <Input
                            id="bordatura"
                            name="bordatura"
                            type="text"
                            value={ordinaForm.bordatura}
                            onChange={handleOrdinaChange}
                            placeholder="Specifica se necessario"
                            className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label className="text-gray-700 font-medium">
                            FORMA MANTOVANA
                          </Label>
                          <Select onValueChange={(value) => handleOrdinaSelectChange('formaMantovana', value)} value={ordinaForm.formaMantovana}>
                            <SelectTrigger className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12">
                              <SelectValue placeholder="Seleziona forma" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="ONDA GRANDE">Onda Grande</SelectItem>
                              <SelectItem value="ONDA PICCOLA">Onda Piccola</SelectItem>
                              <SelectItem value="DRITTA">Dritta</SelectItem>
                              <SelectItem value="GRECA">Greca</SelectItem>
                              <SelectItem value="PUNTINE">Puntine</SelectItem>
                              <SelectItem value="ONDA CON LE PUNTE">Onda con le Punte</SelectItem>
                              <SelectItem value="NO MANTOVANA">No Mantovana</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                      </div>
                    </div>

                    {/* MOTORE E CONSEGNA */}
                    <div className="border-b border-gray-200 pb-6">
                      <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
                        <Settings className="w-5 h-5 text-sky-500" />
                        Motore e Consegna
                      </h4>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label className="text-gray-700 font-medium">
                            MOTORE <span className="text-red-500">*</span>
                          </Label>
                          <Select onValueChange={(value) => handleOrdinaSelectChange('motore', value)} value={ordinaForm.motore}>
                            <SelectTrigger className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12">
                              <SelectValue placeholder="Seleziona motore" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="NO MOTORE">No Motore (manuale)</SelectItem>
                              <SelectItem value="MOTORE BASE CHERUBINI">Motore Base Cherubini</SelectItem>
                              <SelectItem value="MOTORE CON ANEMOMETRO E TELECOMANDO CHERUBINI">Motore con Anemometro e Telecomando</SelectItem>
                              <SelectItem value="MOTORE CON MANOVRA DI SOCCORSO CHERUBINI">Motore con Manovra di Soccorso</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="space-y-2">
                          <Label className="text-gray-700 font-medium">
                            SPEDIZIONE O RITIRO IN SEDE? <span className="text-red-500">*</span>
                          </Label>
                          <Select onValueChange={(value) => handleOrdinaSelectChange('consegna', value)} value={ordinaForm.consegna}>
                            <SelectTrigger className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none h-12">
                              <SelectValue placeholder="Seleziona modalità" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="SPEDIZIONE">Voglio che mi venga spedita (tracking incluso)</SelectItem>
                              <SelectItem value="RITIRO IN SEDE">La ritirerò presso la vostra sede a Ghezzano Pisa</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                      </div>
                    </div>

                    {/* NOTE */}
                    <div className="space-y-2">
                      <Label htmlFor="note" className="text-gray-700 font-medium">
                        NOTE
                      </Label>
                      <Textarea
                        id="note"
                        name="note"
                        value={ordinaForm.note}
                        onChange={handleOrdinaChange}
                        placeholder="Eventuali dettagli o richieste particolari..."
                        rows={3}
                        className="border-gray-300 focus:border-sky-500 focus:ring-sky-500 rounded-none resize-none"
                      />
                    </div>

                    {/* Submit Button */}
                    <Button
                      type="submit"
                      disabled={isSubmittingOrdina}
                      className="w-full bg-sky-500 hover:bg-sky-600 text-white rounded-none h-14 text-lg font-medium"
                    >
                      {isSubmittingOrdina ? (
                        <>
                          <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                          Invio in corso...
                        </>
                      ) : (
                        <>
                          <Send className="w-5 h-5 mr-2" />
                          Invia Richiesta Preventivo
                        </>
                      )}
                    </Button>
                  </form>
                )}
                
                {/* Success State */}
                {termsAccepted && ordinaSubmitted && (
                  <div className="p-12 text-center">
                    <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
                      <CheckCircle className="w-10 h-10 text-green-600" />
                    </div>
                    <h4 className="text-2xl font-medium text-gray-900 mb-3">
                      Richiesta Inviata!
                    </h4>
                    <p className="text-gray-600 mb-4">
                      Grazie per la tua richiesta. Riceverai il <strong>preventivo dettagliato via email</strong>.
                    </p>
                    <div className="bg-sky-50 p-4 rounded-lg border border-sky-200 mb-6 text-left max-w-md mx-auto">
                      <p className="text-sm text-sky-800">
                        <strong>Prossimi passi:</strong>
                      </p>
                      <ol className="text-sm text-sky-700 mt-2 space-y-1 list-decimal list-inside">
                        <li>Riceverai il preventivo via email</li>
                        <li>Conferma l'ordine e procedi al pagamento</li>
                        <li>Mettiamo in produzione la tua tenda</li>
                        <li>Ti avvisiamo quando è pronta!</li>
                      </ol>
                    </div>
                    <Button 
                      onClick={() => setOrdinaSubmitted(false)}
                      className="bg-sky-500 hover:bg-sky-600 text-white rounded-none"
                    >
                      Invia un'altra richiesta
                    </Button>
                  </div>
                )}
              </div>
            </FadeInOnScroll>
          </div>

          {/* ════════════════════════════════════════════════════════════════════ */}
          {/* SEZIONI INFORMATIVE - DOPO IL FORM */}
          {/* ════════════════════════════════════════════════════════════════════ */}

          {/* Cosa puoi acquistare */}
          <div className="grid md:grid-cols-3 gap-8 mt-20 mb-16">
            <FadeInOnScroll delay={100}>
              <div className="p-8 bg-white border border-gray-200 hover:shadow-lg transition-shadow">
                <Package className="w-10 h-10 text-sky-500 mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">Tende da Sole Nuove</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Tende a bracci, a caduta, cappottine nuove complete di struttura e telo.
                </p>
                <ul className="space-y-1 text-xs text-gray-500">
                  <li>• Struttura in alluminio</li>
                  <li>• Telo Tempotest Parà</li>
                  <li>• Accessori inclusi</li>
                </ul>
              </div>
            </FadeInOnScroll>
            <FadeInOnScroll delay={200}>
              <div className="p-8 bg-white border border-gray-200 hover:shadow-lg transition-shadow">
                <Scissors className="w-10 h-10 text-sky-500 mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">Cambi Telo</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Rinnova la tua tenda esistente con un nuovo telo dalla nostra sartoria.
                </p>
                <ul className="space-y-1 text-xs text-gray-500">
                  <li>• Solo il telo nuovo</li>
                  <li>• Tessuto Tempotest Parà</li>
                  <li>• Su misura</li>
                </ul>
              </div>
            </FadeInOnScroll>
            <FadeInOnScroll delay={300}>
              <div className="p-8 bg-white border border-gray-200 hover:shadow-lg transition-shadow">
                <Truck className="w-10 h-10 text-sky-500 mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">Consegna</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Spedizione in tutta Italia o ritiro gratuito presso la nostra sede.
                </p>
                <ul className="space-y-1 text-xs text-gray-500">
                  <li>• Spedizione corriere</li>
                  <li>• Imballaggio professionale</li>
                  <li>• Ritiro in sede Pisa</li>
                </ul>
              </div>
            </FadeInOnScroll>
          </div>

          {/* PERCHÉ COSTA DI PIÙ */}
          <FadeInOnScroll>
            <div className="max-w-4xl mx-auto mb-16">
              <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-8 lg:p-10 rounded-lg border border-amber-200">
                <div className="text-center mb-8">
                  <Award className="w-10 h-10 text-amber-500 mx-auto mb-3" />
                  <h3 className="text-2xl font-light text-gray-900">
                    Perché acquistare da noi anche se costa di più?
                  </h3>
                </div>
                
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div className="p-5 bg-red-50 rounded-lg border border-red-200">
                    <h4 className="font-medium text-red-800 mb-2 text-sm">❌ Tende economiche online</h4>
                    <ul className="space-y-1 text-xs text-red-700">
                      <li>• Tessuti generici che sbiadiscono</li>
                      <li>• Strutture in alluminio sottile</li>
                      <li>• Nessuna garanzia reale</li>
                      <li>• Assistenza inesistente</li>
                    </ul>
                  </div>
                  <div className="p-5 bg-green-50 rounded-lg border border-green-200">
                    <h4 className="font-medium text-green-800 mb-2 text-sm">✓ Le nostre tende</h4>
                    <ul className="space-y-1 text-xs text-green-700">
                      <li>• Solo tessuti Tempotest Parà</li>
                      <li>• Colori garantiti 5 anni</li>
                      <li>• Strutture robuste made in Italy</li>
                      <li>• Assistenza telefonica diretta</li>
                    </ul>
                  </div>
                </div>

                <p className="text-amber-800 font-medium text-center text-sm">
                  💡 La qualità si paga una volta, la mediocrità si paga per sempre.
                </p>
              </div>
            </div>
          </FadeInOnScroll>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* SEZIONE 2: CAPPOTTINE PRONTE IN 24H */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      
      <section id="cappottine-24h" className="py-20 lg:py-28 bg-gradient-to-br from-amber-500 to-orange-500">
        <div className="container mx-auto px-6 lg:px-12">
          <FadeInOnScroll>
            <div className="text-center mb-16 text-white">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur rounded-full text-sm font-medium mb-4">
                <Clock className="w-4 h-4" />
                SERVIZIO EXPRESS
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-light mb-4">
                Cappottine Pronte in 24 Ore
              </h2>
              <p className="text-lg text-white/90 max-w-3xl mx-auto">
                Hai una cappottina da rinnovare? Portala nel nostro laboratorio e ritirala come nuova dopo sole 24 ore.
                <br /><strong>Questo servizio NON è un acquisto online con spedizione.</strong>
              </p>
            </div>
          </FadeInOnScroll>

          {/* Come funziona - Step by step */}
          <FadeInOnScroll delay={100}>
            <div className="max-w-5xl mx-auto mb-16">
              <div className="bg-white rounded-lg p-8 lg:p-12 shadow-2xl">
                <h3 className="text-2xl font-light text-gray-900 text-center mb-10">
                  Come funziona il servizio
                </h3>
                
                <div className="grid md:grid-cols-4 gap-6">
                  {/* Step 1 */}
                  <div className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-amber-100 flex items-center justify-center relative">
                      <span className="text-2xl font-bold text-amber-600">1</span>
                      <div className="hidden md:block absolute left-full top-1/2 w-full h-0.5 bg-amber-200 -translate-y-1/2"></div>
                    </div>
                    <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-amber-500/10 flex items-center justify-center">
                      <CheckSquare className="w-5 h-5 text-amber-600" />
                    </div>
                    <h4 className="font-medium text-gray-900 mb-2">Compila il Form</h4>
                    <p className="text-sm text-gray-600">
                      Inserisci le misure e scegli il colore del tessuto
                    </p>
                  </div>

                  {/* Step 2 */}
                  <div className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-amber-100 flex items-center justify-center relative">
                      <span className="text-2xl font-bold text-amber-600">2</span>
                      <div className="hidden md:block absolute left-full top-1/2 w-full h-0.5 bg-amber-200 -translate-y-1/2"></div>
                    </div>
                    <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-amber-500/10 flex items-center justify-center">
                      <Mail className="w-5 h-5 text-amber-600" />
                    </div>
                    <h4 className="font-medium text-gray-900 mb-2">Ricevi Preventivo</h4>
                    <p className="text-sm text-gray-600">
                      Ti inviamo il preventivo via email con il prezzo esatto
                    </p>
                  </div>

                  {/* Step 3 */}
                  <div className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-amber-100 flex items-center justify-center relative">
                      <span className="text-2xl font-bold text-amber-600">3</span>
                      <div className="hidden md:block absolute left-full top-1/2 w-full h-0.5 bg-amber-200 -translate-y-1/2"></div>
                    </div>
                    <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-amber-500/10 flex items-center justify-center">
                      <CreditCard className="w-5 h-5 text-amber-600" />
                    </div>
                    <h4 className="font-medium text-gray-900 mb-2">Paga e Prenota</h4>
                    <p className="text-sm text-gray-600">
                      Conferma il preventivo e ti diamo giorno e orario di consegna
                    </p>
                  </div>

                  {/* Step 4 */}
                  <div className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-amber-100 flex items-center justify-center">
                      <span className="text-2xl font-bold text-amber-600">4</span>
                    </div>
                    <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-amber-500/10 flex items-center justify-center">
                      <Calendar className="w-5 h-5 text-amber-600" />
                    </div>
                    <h4 className="font-medium text-gray-900 mb-2">Porta e Ritira</h4>
                    <p className="text-sm text-gray-600">
                      Porta la cappottina in sede e ritirala dopo 24 ore
                    </p>
                  </div>
                </div>

                {/* Info importante */}
                <div className="mt-10 p-4 bg-amber-50 rounded-lg border border-amber-200 text-center">
                  <p className="text-amber-800 text-sm">
                    <strong>📍 Sede:</strong> {companyInfo.address.street}, {companyInfo.address.cap} {companyInfo.address.city}
                    <br />
                    <span className="text-amber-600">Il servizio è disponibile solo con consegna e ritiro in sede a Pisa.</span>
                  </p>
                </div>
              </div>
            </div>
          </FadeInOnScroll>

          {/* Tessuti disponibili */}
          <FadeInOnScroll delay={200}>
            <div className="max-w-2xl mx-auto mb-12 text-center">
              <div className="bg-white/10 backdrop-blur p-6 rounded-lg">
                <Palette className="w-10 h-10 text-white mx-auto mb-3" />
                <h4 className="text-white font-medium mb-2">Centinaia di colori disponibili</h4>
                <p className="text-white/80 text-sm mb-4">
                  Sfoglia le collezioni Tempotest Parà e segna il codice colore nel form
                </p>
                <Link to="/tessuti">
                  <Button className="bg-white text-amber-600 hover:bg-gray-100 px-6 py-2 rounded-none text-sm">
                    <Palette className="w-4 h-4 mr-2" />
                    Sfoglia i Tessuti
                  </Button>
                </Link>
              </div>
            </div>
          </FadeInOnScroll>

          {/* FORM CAPPOTTINE 24H - INTEGRATO */}
          <FadeInOnScroll delay={300}>
            <div className="max-w-2xl mx-auto">
              <div className="bg-white rounded-lg shadow-2xl overflow-hidden">
                {/* Header del form */}
                <div className="bg-amber-600 p-6 text-white text-center">
                  <Clock className="w-10 h-10 mx-auto mb-3" />
                  <h3 className="text-2xl font-medium mb-2">
                    Richiedi Preventivo Cappottina 24h
                  </h3>
                  <p className="text-amber-100 text-sm">
                    Compila tutti i campi. Riceverai il preventivo via email entro 24 ore.
                  </p>
                </div>

                {/* Form Nativo */}
                {formSubmitted ? (
                  <div className="p-12 text-center">
                    <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
                      <CheckCircle className="w-10 h-10 text-green-600" />
                    </div>
                    <h4 className="text-2xl font-medium text-gray-900 mb-3">
                      Richiesta Inviata!
                    </h4>
                    <p className="text-gray-600 mb-6">
                      Grazie per la tua richiesta. Ti invieremo il preventivo via email entro 24 ore.
                    </p>
                    <Button 
                      onClick={() => setFormSubmitted(false)}
                      className="bg-amber-500 hover:bg-amber-600 text-white rounded-none"
                    >
                      Invia un'altra richiesta
                    </Button>
                  </div>
                ) : (
                  <form onSubmit={handleCappottinaSubmit} className="p-8 space-y-6">
                    {/* Nota campi obbligatori */}
                    <p className="text-sm text-gray-500 flex items-center gap-1">
                      <span className="text-red-500">*</span> Indica un campo obbligatorio
                    </p>

                    {/* Nome e Cognome */}
                    <div className="space-y-2">
                      <Label htmlFor="nome" className="text-gray-700 font-medium flex items-center gap-2">
                        <User className="w-4 h-4 text-amber-500" />
                        NOME E COGNOME
                      </Label>
                      <Input
                        id="nome"
                        name="nome"
                        type="text"
                        value={cappottinaForm.nome}
                        onChange={handleCappottinaChange}
                        placeholder="La tua risposta"
                        className="border-gray-300 focus:border-amber-500 focus:ring-amber-500 rounded-none h-12"
                      />
                    </div>

                    {/* Indirizzo */}
                    <div className="space-y-2">
                      <Label htmlFor="indirizzo" className="text-gray-700 font-medium flex items-center gap-2">
                        <Home className="w-4 h-4 text-amber-500" />
                        INDIRIZZO <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        id="indirizzo"
                        name="indirizzo"
                        type="text"
                        value={cappottinaForm.indirizzo}
                        onChange={handleCappottinaChange}
                        placeholder="La tua risposta"
                        required
                        className="border-gray-300 focus:border-amber-500 focus:ring-amber-500 rounded-none h-12"
                      />
                    </div>

                    {/* Email */}
                    <div className="space-y-2">
                      <Label htmlFor="email" className="text-gray-700 font-medium flex items-center gap-2">
                        <Mail className="w-4 h-4 text-amber-500" />
                        EMAIL
                      </Label>
                      <Input
                        id="email"
                        name="email"
                        type="email"
                        value={cappottinaForm.email}
                        onChange={handleCappottinaChange}
                        placeholder="La tua risposta"
                        className="border-gray-300 focus:border-amber-500 focus:ring-amber-500 rounded-none h-12"
                      />
                    </div>

                    {/* Telefono */}
                    <div className="space-y-2">
                      <Label htmlFor="telefono" className="text-gray-700 font-medium flex items-center gap-2">
                        <Phone className="w-4 h-4 text-amber-500" />
                        NUMERO <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        id="telefono"
                        name="telefono"
                        type="tel"
                        value={cappottinaForm.telefono}
                        onChange={handleCappottinaChange}
                        placeholder="La tua risposta"
                        required
                        className="border-gray-300 focus:border-amber-500 focus:ring-amber-500 rounded-none h-12"
                      />
                    </div>

                    {/* Divider */}
                    <div className="border-t border-gray-200 pt-6">
                      <p className="text-sm text-gray-600 mb-4 font-medium">
                        📏 Misure della cappottina (opzionale ma consigliato)
                      </p>
                    </div>

                    {/* Misure in row */}
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="larghezza" className="text-gray-700 font-medium flex items-center gap-2">
                          <Ruler className="w-4 h-4 text-amber-500" />
                          LARGHEZZA (cm)
                        </Label>
                        <Input
                          id="larghezza"
                          name="larghezza"
                          type="text"
                          value={cappottinaForm.larghezza}
                          onChange={handleCappottinaChange}
                          placeholder="es. 150"
                          className="border-gray-300 focus:border-amber-500 focus:ring-amber-500 rounded-none h-12"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="sporgenza" className="text-gray-700 font-medium flex items-center gap-2">
                          <Ruler className="w-4 h-4 text-amber-500" />
                          SPORGENZA (cm)
                        </Label>
                        <Input
                          id="sporgenza"
                          name="sporgenza"
                          type="text"
                          value={cappottinaForm.sporgenza}
                          onChange={handleCappottinaChange}
                          placeholder="es. 80"
                          className="border-gray-300 focus:border-amber-500 focus:ring-amber-500 rounded-none h-12"
                        />
                      </div>
                    </div>

                    {/* Codice Tessuto */}
                    <div className="space-y-2">
                      <Label htmlFor="codiceTessuto" className="text-gray-700 font-medium flex items-center gap-2">
                        <Palette className="w-4 h-4 text-amber-500" />
                        CODICE TESSUTO TEMPOTEST
                      </Label>
                      <Input
                        id="codiceTessuto"
                        name="codiceTessuto"
                        type="text"
                        value={cappottinaForm.codiceTessuto}
                        onChange={handleCappottinaChange}
                        placeholder="es. 407/11"
                        className="border-gray-300 focus:border-amber-500 focus:ring-amber-500 rounded-none h-12"
                      />
                      <p className="text-xs text-gray-500">
                        Non sai il codice? <Link to="/tessuti" className="text-amber-600 underline hover:text-amber-700">Sfoglia i tessuti</Link>
                      </p>
                    </div>

                    {/* Note aggiuntive */}
                    <div className="space-y-2">
                      <Label htmlFor="note" className="text-gray-700 font-medium">
                        NOTE AGGIUNTIVE
                      </Label>
                      <Textarea
                        id="note"
                        name="note"
                        value={cappottinaForm.note}
                        onChange={handleCappottinaChange}
                        placeholder="Eventuali dettagli o richieste particolari..."
                        rows={3}
                        className="border-gray-300 focus:border-amber-500 focus:ring-amber-500 rounded-none resize-none"
                      />
                    </div>

                    {/* Submit Button */}
                    <Button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-amber-500 hover:bg-amber-600 text-white rounded-none h-14 text-lg font-medium"
                    >
                      {isSubmitting ? (
                        <>
                          <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                          Invio in corso...
                        </>
                      ) : (
                        <>
                          <Send className="w-5 h-5 mr-2" />
                          Invia Richiesta Preventivo
                        </>
                      )}
                    </Button>
                  </form>
                )}

                {/* Footer con contatti alternativi */}
                <div className="bg-gray-100 p-6">
                  <p className="text-center text-gray-600 text-sm mb-4">
                    Preferisci parlare con noi direttamente?
                  </p>
                  <div className="flex flex-wrap justify-center gap-4">
                    <a href={`tel:+39${companyInfo.phone.replace(/\s/g, '')}`}>
                      <Button variant="outline" className="rounded-none">
                        <Phone className="w-4 h-4 mr-2" />
                        {companyInfo.phone}
                      </Button>
                    </a>
                    <a 
                      href={`https://wa.me/39${companyInfo.mobile.replace(/\s/g, '')}?text=Ciao! Vorrei informazioni sulle cappottine pronte in 24h.`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="bg-green-500 hover:bg-green-600 text-white rounded-none">
                        <MessageCircle className="w-4 h-4 mr-2" />
                        WhatsApp
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </FadeInOnScroll>
        </div>
      </section>

      {/* Payment Options Section */}
      <section className="py-16 lg:py-20 bg-gray-50">
        <div className="container mx-auto px-6 lg:px-12">
          <FadeInOnScroll>
            <div className="text-center mb-8">
              <span className="inline-block text-sm font-medium tracking-widest uppercase mb-4 text-sky-500">
                Metodi di Pagamento
              </span>
              <h2 className="text-2xl md:text-3xl font-light text-gray-900">
                Paga come preferisci
              </h2>
            </div>
            <PaymentOptions variant="full" className="max-w-4xl mx-auto" />
          </FadeInOnScroll>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection
        title="Preferisci un preventivo con montaggio incluso?"
        description="Se vuoi che i nostri tecnici installino la tenda, richiedi un preventivo completo."
        variant="light"
      />
    </Layout>
  );
};

export default ShopPage;
